import * as types from '../actions/types'
import Immutable from 'immutable'

import { tableCols, findValues } from '../containers/Garantias'
import { garantia, isPrimitive } from '../utils/helpers'

const columnas = Immutable.fromJS(tableCols)

const INITIAL_STATE = Immutable.fromJS({
	garantias: [],
	page: 1,
	showRecords: 100,
	totalRecords: 0,
	orderBy: {
		field: null,
		asc: false
	},
	modalCreate: {
		title: '',
		mode: '',
		show: false,
		data: null,
		btnDisabled: false
	},
	modalDelete: {
		show: false,
		action: null,
		message: null
	},
	modalFilter: {
		show: false,
		filters: []
	},
})

export default function (state = INITIAL_STATE, action) {
	let id
	let data
	let index
	switch (action.type) {
		case types.OBTENER_GARANTIAS:
			state = state.set('garantias', Immutable.fromJS(action.payload.data))
			state = state.set('page', action.payload.page)
			state = state.set('totalRecords', action.payload.totalRecords)
			return state
		case types.CONMUTAR_SELECCION_GARANTIA:
			state = state.setIn(['garantias', action.payload.index, 'selected'], action.payload.checked)
			return state
		case types.CONMUTAR_SELECCION_TODOS_GARANTIAS:
			state.get('garantias').forEach((x, n) => {
				if (action.payload) {
					if (x.get('Visible')) {
						state = state.setIn(['garantias', n, 'selected'], action.payload)
					}
				} else {
					state = state.setIn(['garantias', n, 'selected'], action.payload)
				}
			})
			return state
		case types.ORDENAR_GARANTIAS:
			state = state.set('orderBy', action.payload.orderBy)
			return state
		case types.MOSTRAR_MODAL_CREAR_GARANTIA:
			state = state.setIn(['modalCreate', 'show'], action.payload.show)
			state = state.setIn(['modalCreate', 'title'], action.payload.title)
			state = state.setIn(['modalCreate', 'mode'], action.payload.mode)
			if (action.payload.mode === 'create') {
				state = state.setIn(['modalCreate', 'data'], Immutable.fromJS(garantia()))
			} else if (action.payload.mode === 'edit') {
				index = state.get('garantias').findIndex(x => x.get('id') === action.payload.id)
				state = state.setIn(['modalCreate', 'data'], state.getIn(['garantias', index]))
			}
			return state
		case types.MODIFICAR_INPUTS_GARANTIAS:
			if (isPrimitive(action.payload.value)) {
				state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
			} else {
				if (action.payload.immutable === false) {
					state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
				} else {
					state = state.setIn(`${action.payload.path}`.split('.'), Immutable.fromJS(action.payload.value))
				}
			}
			return state
		case types.CREAR_ACTUALIZAR_GARANTIA:
			id = action.payload.id
			index = state.get('garantias').findIndex(x => x.get('id') === id)
			if (index !== -1) {
				state = state.setIn(['garantias', index], Immutable.fromJS(action.payload))
			} else {
				state = state.set('garantias', state.get('garantias').push(Immutable.fromJS(action.payload)))
			}
			state = state.setIn(['modalCreate', 'show'], false)
			state = state.setIn(['modalCreate', 'title'], '')
			state = state.setIn(['modalCreate', 'mode'], '')
			state = state.setIn(['modalCreate', 'data'], null)
			return state
		case types.DESHABILITAR_BOTON_MODAL_GARANTIAS:
			state = state.setIn(['modalCreate', 'btnDisabled'], action.payload)
			return state
		case types.MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_GARANTIA:
			state = state.setIn(['modalDelete', 'show'], action.payload.open)
			state = state.setIn(['modalDelete', 'action'], action.payload.action)
			state = state.setIn(['modalDelete', 'message'], action.payload.message)
			return state
		case types.ELIMINAR_GARANTIA:
			index = state.get('garantias').findIndex(x => x.get('id') === action.payload)
			state = state.deleteIn(['garantias', index])
			state = state.setIn(['modalDelete', 'show'], false)
			state = state.setIn(['modalDelete', 'action'], null)
			state = state.setIn(['modalDelete', 'message'], null)
			return state
        case types.MOSTRAR_MODAL_CRITERIOS_FILTRADO_GARANTIAS:
            state = state.setIn(['modalFilter', 'show'], action.payload)
            return state
        case types.ADICIONAR_CRITERIO_FILTRADO_GARANTIAS:
            const firstCol = columnas.first()
            state = state.updateIn(['modalFilter', 'filters'], filter => filter
                .push(Immutable.fromJS({ 
                    column: firstCol.get('Value'),
                    operator: '===',
                    value: '',
                    checked: false,
                    comparison: firstCol.get('Type'),
                    apply: false
                }))
            )
            return state
        case types.ELIMINAR_CRITERIO_FILTRADO_GARANTIAS:
            state = state.setIn(['modalFilter', 'filters'], state.getIn(['modalFilter', 'filters']).filter(item => !item.get('checked')))
            return state
        case types.CONMUTAR_SELECCION_CRITERIO_FILTRADO_GARANTIAS:
            state = state.setIn(['modalFilter', 'filters', action.payload.index, 'checked'], action.payload.checked)
            return state
        case types.MODIFICAR_CRITERIO_FILTRADO_GARANTIAS:
            if (action.payload.attr === 'column') {
                state = state.setIn(['modalFilter', 'filters', action.payload.index, 'comparison'], columnas.find(x => x.get('Value') === action.payload.value).get('Type'))
            }
            state = state.setIn(['modalFilter', 'filters', action.payload.index, action.payload.attr], action.payload.value)
            return state
        case types.APLICAR_CRITERIOS_FILTRADO_GARANTIAS:
            state = state.updateIn(['modalFilter', 'filters'], filter => filter
                .map(x => {
                    x = x.set('apply', true)
                    return x
                })
            )
            return state
		case types.CAMBIAR_MOSTRAR_REGISTROS_GARANTIAS:
            state = state.set('showRecords', action.payload)
            return state
	   default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/garantias.js